import { Form, InputNumber } from "antd";
import { Rule } from "antd/es/form";
import React from "react";

type Props = {
  index: number;
  styles: React.CSSProperties;
  rules: Rule[];
  label: string;
};

export default (props: Props) => {
  return (
    <Form.Item
      label={props.label}
      name={[props.index, "value"]}
      rules={props.rules}
      style={{ width: "100%", flexGrow: 1, ...props.styles }}
    >
      <InputNumber style={{ width: "100%" }} type="number" />
    </Form.Item>
  );
};
